import LRU from 'lru-cache';
import hash from 'object-hash';
import { debug } from '@/constants/Constants';

const options = {
  max: 500,
  maxAge: 1000 * 60,
};

const cacheManager = new LRU(options);

cacheManager.genKey = function (options = {}) {
  const { g_tk, ...restOptions } = options;
  try {
    return hash(restOptions);
  } catch (error) {
    return '';
  }
};

if (debug) {
  window.__cacheManager__ = cacheManager;
}

export default cacheManager;
